"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
class GTMServerDriver {
    constructor() {
        this.name = 'GTMServerDriver';
    }
    load() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return false;
        });
    }
    supportsEvent() {
        return false;
    }
    track() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return;
        });
    }
}
exports.default = GTMServerDriver;
//# sourceMappingURL=gtm.server-driver.js.map